import React, { MouseEvent } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

import { createSegmentedControlSx } from 'pages/Mailer/styles'

type SegmentedSelectorProps<T extends string> = {
  value: T
  options: T[]
  onChange: (value: T) => void
  getOptionLabel: (option: T) => string
  ariaLabel: string
}

const SEGMENT_MIN_WIDTH = 72

const SegmentedSelector = <T extends string,>({
  value,
  options,
  onChange,
  getOptionLabel,
  ariaLabel,
}: SegmentedSelectorProps<T>) => {
  const handleChange = (_event: MouseEvent<HTMLElement>, nextValue: T | null) => {
    if (nextValue === null) return
    onChange(nextValue)
  }

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
      aria-label={ariaLabel}
      sx={createSegmentedControlSx(SEGMENT_MIN_WIDTH)}
    >
      {options.map(option => (
        <ToggleButton key={option} value={option}>
          {getOptionLabel(option)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default SegmentedSelector
